export const TAG_SHAPES = ['square', 'pill'] as const;
export const TAG_SIZES = ['xs', 'sm', 'md'] as const;
export const TAG_COLORS = [
  'grey',
  'red',
  'orange',
  'yellow',
  'green',
  'blue',
  'darkblue',
  'indigo',
] as const;

export type STagShape = (typeof TAG_SHAPES)[number];
export type STagSize = (typeof TAG_SIZES)[number];
export type STagColor = (typeof TAG_COLORS)[number];

/** 사이즈별 레이아웃/타이포 (token.json component.tag 기준) */
export const TAG_SIZE_CONFIG: Record<
  STagSize,
  {
    height: number;
    paddingX: number;
    gap: number;
    radius: number;
    iconSize: number;
    fontSize: number;
    fontWeight: number;
    lineHeight: number;
  }
> = {
  xs: {
    height: 20,
    paddingX: 8,
    gap: 4,
    radius: 6,
    iconSize: 12,
    fontSize: 11,
    fontWeight: 500,
    lineHeight: 18,
  },
  sm: {
    height: 24,
    paddingX: 8,
    gap: 4,
    radius: 6,
    iconSize: 16,
    fontSize: 12,
    fontWeight: 700,
    lineHeight: 20,
  },
  md: {
    height: 28,
    paddingX: 12,
    gap: 6,
    radius: 8,
    iconSize: 16,
    fontSize: 14,
    fontWeight: 700,
    lineHeight: 24,
  },
};
